import { DynamicFormV2Palette } from "@mui/material";

export type FormPaymentSummaryComponentTokenType = {
  backgroundColor: string;
  titleTextColor: string;
  textColor: string;
  borderColor: string;
  totalSectionBackgroundColor: string;
  totalSectionTextColor: string;
  renewalDateTextColor: string;
};

export const assignPaymentSummaryComponentTokens = (
  formsPalette: DynamicFormV2Palette["forms"],
  mode: "light" | "dark"
) => {
  const isLightMode = mode === "light";

  return {
    backgroundColor: isLightMode ? formsPalette.surface.supershy : formsPalette.surface.intense,
    titleTextColor: formsPalette.text.intense,
    textColor: formsPalette.text.moderate,
    borderColor: isLightMode ? formsPalette.border.moderate : formsPalette.border.supershy,
    totalSectionBackgroundColor: formsPalette.surface.quiet,
    totalSectionTextColor: formsPalette.text.intense,
    renewalDateTextColor: formsPalette.text.brand,
  } as FormPaymentSummaryComponentTokenType;
};
